import { IconType } from '@sato/components';

import { ILinkButtonFields } from '@/contentful/types';

const buttonVariants = ['contained', 'outlined', 'text'] as const;
const iconPositions = ['left', 'right'] as const;

export type HomeChangerSwitchButtonParameters = {
  /** Internal path or external URL to navigate to after switching the apartment, e.g. moving-in instructions */
  url?: string;
  variant?: NonNullable<ILinkButtonFields['variant']>;
  icon?: IconType;
  iconPosition?: NonNullable<ILinkButtonFields['iconPosition']>;
  /** Only Tailwind classes that are used elsewhere in the codebase (or safelisted) are available */
  className?: string;
};

const isOneOf = <T extends string>(
  values: readonly T[],
  value: unknown
): value is T => values.some((validValue) => validValue === value);

/** Parses widget parameters entered in Contentful, ignoring invalid values */
export const parseHomeChangerSwitchButtonParameters = (
  parameters: Record<string, unknown> | undefined
): HomeChangerSwitchButtonParameters => {
  const { url, variant, icon, iconPosition, className } = parameters ?? {};

  return {
    url: typeof url === 'string' && url ? url : undefined,
    variant: isOneOf(buttonVariants, variant) ? variant : undefined,
    icon: typeof icon === 'string' && icon ? (icon as IconType) : undefined,
    iconPosition: isOneOf(iconPositions, iconPosition)
      ? iconPosition
      : undefined,
    className:
      typeof className === 'string' && className ? className : undefined,
  };
};
